import { useEffect, useMemo, useState } from "react";
import {
  SettlementExpenseDto,
  SettlementResponse,
  SettlementTournament,
  getExpense,
  getSettlement,
} from "../../../api/settlement";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import { getDateWith9AMRule } from "../../../utils/date";

export const useSettlement = () => {
  const pub = useRecoilValue(pubState);
  const [tournamentList, setTournamentList] = useState<SettlementTournament[]>(
    []
  );
  const [expenseList, setExpenseList] = useState<SettlementExpenseDto[]>([]);
  const [totalPoint, setTotalPoint] = useState(0);
  const [date, setDate] = useState<string>(getDateWith9AMRule());
  const [data, setData] = useState<SettlementResponse>();
  const expenditure = useMemo(
    () => expenseList.reduce((sum, curr) => (sum += curr.amount), 0),
    [expenseList]
  );

  const getSettlementData = async () => {
    if (!pub) {
      return;
    }
    try {
      const res = await getSettlement(pub.id, date);
      setData(res);
      setTournamentList(res.tournaments);
      setTotalPoint(res.totalMemberPoint);
    } catch (e) {
      //정산할 데이터가 없는 상태
      setTournamentList([]);
    }
  };

  const getExpenseData = async () => {
    if (!pub) return;
    try {
      const res = await getExpense(pub.id, date);
      setExpenseList(res);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getSettlementData();
    getExpenseData();
  }, [date]);

  return {
    tournamentList,
    expenseList,
    setExpenseList,
    totalPoint,
    setTotalPoint,
    expenditure,
    date,
    setDate,
    data,
    // 데이터 호출
    getSettlementData,
    getExpenseData,
  };
};
